// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__Ip1l7"};